import { render, staticRenderFns } from "./LastSelfRatingsExternalWidget.vue?vue&type=template&id=a4de57ca"
import script from "./LastSelfRatingsExternalWidget.vue?vue&type=script&lang=js"
export * from "./LastSelfRatingsExternalWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4de57ca')) {
      api.createRecord('a4de57ca', component.options)
    } else {
      api.reload('a4de57ca', component.options)
    }
    module.hot.accept("./LastSelfRatingsExternalWidget.vue?vue&type=template&id=a4de57ca", function () {
      api.rerender('a4de57ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/LastSelfRatingsExternalWidget.vue"
export default component.exports